import { render, staticRenderFns } from "./imageSelector.vue?vue&type=template&id=dab24b3a&scoped=true&"
import script from "./imageSelector.vue?vue&type=script&lang=js&"
export * from "./imageSelector.vue?vue&type=script&lang=js&"
import style0 from "./imageSelector.vue?vue&type=style&index=0&id=dab24b3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab24b3a",
  null
  
)

export default component.exports